function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_107_179)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.9897 0H0.0102539C0.00459083 0 0 0.00452525 0 0.0101074V34.4899C0 34.4955 0.00459083 34.5 0.0102539 34.5H34.9897C34.9954 34.5 35 34.4955 35 34.4899V0.0101074C35 0.00452525 34.9954 0 34.9897 0Z",
  fill: "#5281B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.7304 24.46C19.0722 24.3926 19.6874 24.2578 19.6874 23.4492C19.6874 23.4492 19.6191 21.4277 20.5761 21.1582C21.5331 20.8887 22.7636 23.1123 24.0624 23.9883C25.0194 24.5947 25.7714 24.5274 25.7714 24.5274L29.2577 24.46C29.2577 24.46 31.0351 24.3252 30.2148 22.9102C30.1464 22.7754 29.5995 21.8994 27.5487 20.0801C25.4296 18.0586 25.7714 18.3955 28.3007 14.959C29.873 12.8701 30.5566 11.5899 30.3515 11.1182C30.078 10.6465 28.9843 10.7139 28.9843 10.7139H25.0878C24.6777 10.7139 24.4726 10.7813 24.2675 11.1182C24.2675 11.1182 23.6523 12.8027 22.8319 14.1504C21.123 17.0479 20.4394 17.1826 20.0976 16.9805C19.4823 16.6436 19.6191 15.3633 19.6191 14.4873C19.6191 11.4551 20.0976 10.377 18.7304 10.1074C17.8417 9.97266 14.6972 9.8379 13.7402 10.3096C13.2616 10.5791 12.9882 11.0508 13.1933 11.1182C13.3984 11.1182 14.0136 11.1856 14.3554 11.5899C14.9023 12.4658 14.9706 16.6436 14.2187 17.0479C13.1933 17.7891 10.5956 12.8701 9.98039 11.2529C9.84367 10.8486 9.63859 10.7813 9.16007 10.6465H5.40031C4.99015 10.6465 4.37492 10.7139 4.64835 11.5225C6.49406 15.2959 10.3222 24.5274 17.2265 24.46H18.7304Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_107_179"
}, /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 34.5,
  rx: 6,
  fill: "white"
})));

function SvgVk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.8a5e81372661eeac5e8c273ded84b5cc.svg";
export { ForwardRef as ReactComponent };